import { useSwitchState } from '@vtex/admin-ui';
import { SwitchProps } from './switch.component';

interface UseSwitchResult {
  switchState: ReturnType<typeof useSwitchState>;
}

export const useSwitch = ({
  value,
  onSwitch,
}: SwitchProps): UseSwitchResult => {
  const switchState = useSwitchState({
    value: value ?? undefined,
    setValue: value => {
      if (onSwitch) onSwitch(value);
    },
  });

  return {
    switchState,
  };
};
